import { render } from "./DelayApplyDetails.vue?vue&type=template&id=33b3d81b&scoped=true&ts=true"
import script from "./DelayApplyDetails.vue?vue&type=script&lang=ts"
export * from "./DelayApplyDetails.vue?vue&type=script&lang=ts"

import "./DelayApplyDetails.vue?vue&type=style&index=0&id=33b3d81b&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b3d81b"]])

export default __exports__